@if (myConvocations.length > 0) {
<ul class="convocations-list">
  @for (c of myConvocations; track c) {
  <li class="convocation-item" [routerLink]="['convocations']">
    <div class="convocation-icon"><em class="fal fa-calendar-check"></em></div>
    <div class="convocation-content">
      <span class="convocation-time">
        {{ c.ecawinEvent.dateStart | date : 'EEEE d MMM à HH:mm' }}
        <em class="fal fa-location-arrow"></em> {{ c.ecawinEvent.getLocation() }}
      </span>
      <p
        class="convocation-summary"
        [ngStyle]="{ 'text-decoration': c.absenceDate ? 'line-through' : '' }"
      >
        {{ c.ecawinEvent.summary }}
      </p>
      @if (c.absenceDate) {
      <span class="convocation-absence">{{ c.absenceReason }}</span>
      }
    </div>
  </li>
  }
</ul>
} @else {
<div class="empty-state">
  <div class="empty-state-icon"><em class="fal fa-calendar-check"></em></div>
  <p class="empty-state-text">Aucune convocation à venir</p>
</div>
}
<a class="widget-viewall" [routerLink]="['/convocations']">Voir toutes mes convocations →</a>
